<div class="skeleton">
  <div class="flex">
    <div class="s pic"></div>
    <div>
      <div class="s name"></div>
      <div class="s bio"></div>
    </div>
  </div>
</div>